<template>
  <div>
    <div v-if="rokomoTests && rokomoTests.length">
      <div class="row" style="border: 1px solid #e0e0e0">
        <div class="d-flex col-12 justify-content-between px-3 py-2" style="background-color: #f8f8fb;">
          <div><h5 class="text-list-rokomo-7 mb-1">履歴照会</h5></div>
          
        </div>
        <div class="p-0">
          <Spliter :initialLeftWidth="250">
            <template #left>
              <div class="col-12 px-1">
                <div class="mt-2 px-1">
                  <b-button class="w-lg btn-edit" :disabled="listIds.length === 0" :class="{'bg-disabled': listIds.length === 0}" @click="exportExcel()">Excel出力</b-button>
                </div>
                <div class="table-responsive mt-2 mb-0 scroll" :style="{maxHeight: isExpand ? '67vh': '50vh'}">
                  <vue-loadmore :on-refresh="onRefresh" :on-loadmore="onLoad" loading-text="読み込み中" :finished="finished" finished-text=" ">
                    <table class="table align-middle mb-0" id="table">
                      <tbody>
                      <tr id="tr" v-for="(history, index) in rokomoTests" :key="index" @click="getRokomoTestResult(index), (clickIndex = index)" style="cursor: pointer" >
                        <td class="text-center pe-1" :class="{ 'bg-active-rokomo': index === clickIndex }">
                          <input class="form-check-input" type="checkbox" @click="checkedRokomo(history.id)" id="formCheckRight2" :checked="isChecked(history.id)" style="font-size: 24px; margin: 0"/>
                        </td>
                        <td width="100%" :class="{ 'bg-active-rokomo': index === clickIndex }" class="px-1">
                          <h5 class="text-list-rokomo-7 mb-0">
                            {{ history.created_at | fomatDate2 }}
                          </h5>
                        </td>
                        
                      </tr>
                      </tbody>
                    </table>
                  </vue-loadmore>
                </div>
              </div>
            </template>

            <template #right>
              <div class="col-12 ps-3" style="font-size: 16px;">
                <div class="w-100 d-flex justify-content-end mb-3 px-3 mt-2">
                  <button v-if="(role === 'admin' && !edit) || (role === 'hospital' && !edit && time_out_facility === null)" class="w-lg btn btn-delete"@click="handlerDelete(testResult.id)">
                    削除
                  </button>
                  <button v-if="(role === 'admin' && !edit) || (role === 'hospital' && !edit && time_out_facility === null)" class="w-lg btn-edit" @click="toEdit">
                    編集
                  </button>
                </div>
                <div class="row mt-8">
                  <div class="row mt-8">
                    <div class="col-8"><strong>KL分類（左脚）:</strong> {{ testResult.kl_left}}</div>
                    <div class="col-4"><strong>KL分類（右脚）:</strong> {{ testResult.kl_right}}</div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-8"><strong>立ち上がりテスト：</strong> {{ standUpChoices[testResult.stand_up_choice_id]?.name }}</div>
                    <div class="col-4"><strong>ロコモ度：</strong> {{ testResult.stand_up_choice_value }}</div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-8"><strong>WBI:</strong> {{ standUpChoices[testResult.stand_up_choice_id]?.wbi}}</div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-8"><strong>2ステップテスト：</strong> {{ testResult.two_step ? testResult.two_step + '（２ステップ値）': '' }} </div>
                    <div class="col-4"><strong>ロコモ度：</strong><a v-if="testResult.two_step"> {{ twoStepResult(testResult.two_step) }}</a></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-8"><strong>ロコモ25：</strong> {{ testResult.locomo25_score != null ? testResult.locomo25_score + ' 点' : ''}}</div>
                    <div class="col-4"><strong>ロコモ度：</strong> {{ testResult.locomo25_rank }}</div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-8"><strong>5m歩行テスト：</strong> {{ testResult.five_meter ? testResult.five_meter + 'm / 秒' : '' }}   </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-8"><strong>痛みの評価-eVAS：</strong> {{ testResult.vas }}</div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-8"><strong>FIMの評価表：</strong> {{ testResult.fim ? testResult.fim + ' 点' : '' }}</div>
                  </div>
                  <div v-if="testResult.fim" class="col-12">
                    <table class="table custome-table">
                      <thead>
                        <tr>
                          <th class="col-5">評価項目</th>
                          <th class="col-2">点数</th>
                          <th class="col-5">コメント</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="answer in fimAnswers" :key="answer.id">
                          <td>{{ getFimQuestionName(answer.fim_question_id) }} {{ answer.choices ? '（'+ answer.choices + '）' : ''}} </td>
                          <td>{{ answer.answer }}</td>
                          <td>{{ answer.note }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style="margin-bottom: 30px;">
                    <div class="row mt-3">
                      <div class="col-8"><strong>BIの評価表：</strong> {{ testResult.bi ? testResult.bi + ' 点' : '' }}</div>
                    </div>
                    <div v-if="testResult.bi" class="col-12">
                      <table class="table custome-table">
                        <thead>
                          <tr>
                            <th class="col-5">評価項目</th>
                            <th class="col-2">点数</th>
                            <th class="col-5">質問内容</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="answer in biAnswers" :key="answer.id">
                            <td>{{ getBiQuestionName(answer.bi_question_id) }} </td>
                            <td>{{ answer.answer }}</td>
                            <td>{{ answer.note }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </Spliter>
        </div>
      </div>
    </div>

    <div v-else class="undefine">
      <img src="@/assets/images/no-data.jpg" alt="" />
      <div class="mt-3">詳細データはありません。</div>
    </div>
  </div>
</template>

<script>
import { filter } from "../../helpers/Vue-Filter";
import { hospitalMethods } from "@/state/helpers";
import { hospitalComputed } from "@/state/helpers";
import api from "@/api";
import Swal from "sweetalert2";
import {getProfile} from "../../helpers/Auth";
import moment from 'moment';
import Spliter from "./spliter.vue";

export default {
  filters: {
    ...filter,
  },
  components: {Spliter},
  props: ["rokomoTests", "pagination", "theme", "time_out_facility", "userInfor", "isExpand"],
  data() {
    return {
      clickIndex: 0,
      testResult: {},
      flagPDFAll: false,
      listIds: [],
      list: [],
      page: 1,
      finished: false,
      standUpChoices: [],
      fimAnswers: '',
      biAnswers: '',
      fimQuestionList:{},
      biQuestionList:{},
      edit: false,
      role: getProfile().role.name,
    };
  },

  async created() {
    if (this.rokomoTests && this.rokomoTests.length) {
      this.getRokomoTestResult(0);
    }

    await this.fetchBiQuestionsList();
    await this.fetchFimQuestionsList();
  },

  async mounted() {
    await this.refreshStandUpChoices();
    this.fetchPage();
  },

  computed: {
    ...hospitalComputed,
  },

  watch: {
    rokomoTests: {
      handler() {
        if (this.rokomoTests && this.rokomoTests.length > 0) {
          this.getRokomoTestResult(this.clickIndex);
        }
      },
    },
  },

  methods: {
    ...hospitalMethods,

    async refreshStandUpChoices() {
      const res = await api.listStandUpChoices();
      this.standUpChoices = [{id: null, name: '', value: null}, ...res.data];
    },

    twoStepResult(val) {
      if (val >= 1.1 && val < 1.3) {
        return 1;
      }

      if (val >= 0.9 && val < 1.1) {
        return 2;
      }

      if (val >= 0 && val < 0.9) {
        return 3;
      }

      return null;
    },

    onRefresh(done) {
      this.list = [];
      this.finished = false;
      this.fetchPage();

      done();
    },

    onLoad(done) {
      if (this.page <= this.pagination.last_page) {
        this.loadMore();
      } else {
        // all data loaded
        this.finished = true;
      }
      done();
    },

    fetchPage() {
      for (let i = 0; i <= this.pagination.last_page; i++) {
        this.list.push(this.list.length + 1);
      }
      this.page++;
    },

    loadMore() {
      this.$emit("loadMoreRokomo");
      this.page++;
    },

    async getRokomoTestResult(index) {
      this.testResult = this.rokomoTests[index];
      if (this.testResult && this.testResult.fim_survey_id) {
        if (this.testResult.fim_survey_id) {
          await this.fetchFimAnswersById(this.testResult.fim_survey_id);
        }
        if(this.testResult.bi_survey_id){
          await this.fetchBiAnswersById(this.testResult.bi_survey_id);
        }
      } else {
        this.fimAnswers = null;
        this.biAnswers = null;
      }
    },

    async fetchFimQuestionsList(){
      try {
        const res = await api.getFimQuestion();
        this.fimQuestionList = res.data;
      } catch (error) {
        console.error(error);
      }
    },

    async fetchBiQuestionsList(){
      try {
        const response = await api.getBiQuestion();
        this.biQuestionList = response.data;
      } catch (error) {
        console.error(error);
      }
    },

    async fetchFimAnswersById(id) {
      try {
        const response = await api.getFimAnswersById(id);
        this.fimAnswers = response.data;
      } catch (error) {
        console.error(error);
      }
    },

    async fetchBiAnswersById(id) {
      try {
        const response = await api.getBiAnswersById(id);
        this.biAnswers = response.data;
      } catch (error) {
        console.error(error);
      }
    },

    getFimQuestionName(fimQuestionId) {
      if(fimQuestionId){
        const question = this.fimQuestionList.find(question => question.id === fimQuestionId);
        return question ? question.question : '';
      } else {
        return '';
      }
    },

    getBiQuestionName(biQuestionId) {
      if(biQuestionId && this.biQuestionList){
        const question = this.biQuestionList.find(question => question.id === biQuestionId);
        return question ? question.question : '';
      } else {
        return '';
      }
    },

    checkedRokomo(id) {
      const index = this.listIds.indexOf(id);
      if (index !== -1) {
        this.listIds.splice(index, 1);
      } else {
        this.listIds.push(id);
      }
    },

    isChecked(id) {
      if (this.listIds.includes(id)) return true;
      return false;
    },

    isCheckedAll() {
      if (this.rokomoTests.length === this.listIds.length) return true;
      return false;
    },

    selectAll($event) {
      this.flagPDFAll = $event.target.checked;
      if (!this.flagPDFAll) {
        this.listIds = [];
      } else {
        this.listIds = this.rokomoTests.map((e) => e.id);
      }
    },

    exportPDF() {
      if (this.flagPDFAll || this.listIds.length === this.rokomoTests.length) {
        this.$emit("pdfRokomoTests");
      } else {
        this.$emit("pdfRokomoTests", this.listIds);
      }

      this.listIds = [];
      this.flagPDFAll = false;
    },

    exportExcel() {
      const payload = {};
      payload.ids = this.listIds.toString();
      try {
        const formattedDate = moment().format('YYYYMMDD');
        api.exportHistory('rokomo', payload, `ロコモ度テスト等_${this.userInfor.mobile}_${this.userInfor.patient_id}_${formattedDate}`);
      } catch (error) {
        console.log(error);
      }
    },

    toEdit(){
      this.$emit("enableEditRokomo", this.testResult);
    },

    async handlerDelete(id) {
      try {
        Swal.fire({
          title: "",
          text: "削除しますか?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: this.theme === 'normal' ? "#8fc31f" : "#395299",
          cancelButtonColor: "#FF5858",
          confirmButtonText: "はい",
          cancelButtonText: "いいえ",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const res = await api.deleteRokomoTest(id);
            if (res.status === 200) {
              window.toastr.success("削除に完了しました");
            }
            this.$emit("reloadRokomo");
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Noto Sans JP";
}
.text-list-rokomo-7 {
  color: #404040;
  font-size: 16px;
  font-weight: 700;
}

.text-list-time {
  color: #404040;
  font-weight: 400;
  font-size: 14px;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.bg-active-rokomo {
  background: #b8e060;
}

.text-end {
  align-items: end;
}

.scroll {
  // max-height: 50vh;
  overflow-y: scroll;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.undefine {
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #404040;
}

.select-all {
  overflow-y: scroll;
}

.text-right {
  text-align: right;
}


.custome-table tbody tr {
  height: 20px !important;
}

.btn-edit {
  color: white;
  background-color: #8fc31f;
  border: none;
  border-radius: 4px;
  padding: 5px;
  font-size: 14px;
  margin-left: 24px;
}

.btn-delete {
  color: white;
  background-color: #f46a6a;
  border: none;
  border-radius: 4px;
  padding: 5px;
  font-size: 14px;
  margin-left: 24px;
}
.bg-disabled {
  background: #ffffff !important;
  color: #d3d3d3 !important;
}
</style>
